<template>
  <van-popup
    v-model="show"
    position="bottom"
    :round="true"
    closeable
    close-icon-position="top-right"
    :style="{ 'padding-top': '25px' }"
  >
    <div :class="preClass">
      <income
        v-if="type === '收入情况'"
        :dateType="dateType"
        :year="year"
        :begin_time="begin_time"
        :end_time="end_time"
        :subjectData="subjectData"
        :data="data"
      ></income>
      <div v-else>
        <div class="title-wrap">
          <p v-show="dateType === 0">
            本年累计发生前{{ type === "财务费用" ? "一" : "三" }}名（{{
              beginMonth
            }}- {{ endMonth }}）
          </p>
          <p v-show="dateType === 1">
            去年累计发生前{{ type === "财务费用" ? "一" : "三" }}名（{{
              beginMonth
            }}- {{ endMonth }}）
          </p>
        </div>
        <base-table :data="topThreeData" :headers="headers"></base-table>
      </div>
    </div>
  </van-popup>
</template>

<script>
import income from "./components/income.vue";
import { mapGetters } from "vuex";

export default {
  components: { income },
  data() {
    return {
      preClass: "financial-report-detail",
      show: false,
      data: {},
      subjectData: [],
      type: "收入情况",
      dateType: 0,
      year: "",
      begin_time: "",
      end_time: "",
      headers: ["科目名称", "金额"],
      topThreeData: []
    };
  },
  watch: {
    show: {
      handler: function() {
        if (this.show) {
          this.init();
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters([
      "currClient",
      "currDate",
      "currDateMonth",
      "smallScale",
      "currClientDetail"
    ]),
    beginMonth() {
      return this.begin_time.substr(0, 7).replace("-", "/");
    },
    endMonth() {
      return this.end_time.substr(0, 7).replace("-", "/");
    }
  },
  methods: {
    init() {
      this.setDate();
      this.subjectData = [];
      this.topThreeData = [];
      let balanceData = JSON.parse(window.localStorage.getItem("balanceData"));
      if (balanceData) {
        this.setTableData(balanceData);
      } else {
        this.getBalanceData();
      }
    },
    getBalanceData() {
      this.$store.commit("app/SET_LOADING_STATUS", true);

      let params = {
        begin_ym: this.begin_time,
        end_ym: this.end_time,
        page: 1,
        rows: 99999999
      };
      this.$axios
        .post("/account-book/account-balance", params)
        .then(res => {
          if (res.success && res.rows) {
            window.localStorage.setItem(
              "balanceData",
              JSON.stringify(res.rows)
            );
            this.setTableData(res.rows);
          }
        })
        .finally(_ => {
          this.$store.commit("app/SET_LOADING_STATUS", false);
        });
    },
    setTableData(balanceData) {
      let resultArr = [];
      let label = "";
      switch (this.type) {
        case "收入情况":
          label = "主营业务收入";
          break;
        case "成本情况":
          label = "主营业务成本";
          break;
        case "销售费用":
          label = "销售费用";
          break;
        case "管理费用":
          label = "管理费用";
          break;
        case "财务费用":
          label = "财务费用";
          break;
        case "利润总额":
          label = "利润总额";
          break;
      }
      balanceData.forEach(item => {
        if (item.name === label) {
          item.children.forEach(incomItem => {
            incomItem =  {
              ...incomItem,
              title: incomItem.name,
              value: incomItem.year_debit,
              align: "around",
              color: "blue",
              filter: "toThousandFilter"
            };
            if(incomItem.value>0){
              resultArr.push(incomItem)
            }
          });
        }
      });
      if (label === "主营业务收入") {
        this.subjectData = resultArr;
      } else {
        resultArr.sort((item1, item2) => {
          if (item1.value < item1.value) return -1;
          else if (item1.value > item1.value) return 1;
          else return 0;
        });
        if (label === "财务费用") {
          this.topThreeData = resultArr.slice(0, 1);
          return;
        }
        this.topThreeData = resultArr.slice(0, 3);
      }
    },
    setDate() {
      let year = new Date().getFullYear();
      let month = new Date(this.currDate).getMonth() + 1;
      month = month > 10 ? month : "0" + month;
      if (this.dateType === 0) {
        this.year = year;
        this.begin_time = year + "-01-01";
        this.end_time = this.currDate;
      } else {
        this.year = year - 1;
        this.begin_time = year - 1 + "-01-01";
        this.end_time = year - 1 + "-" + month + "-01";
      }
    }
  }
};
</script>

<style lang="less">
.financial-report-detail {
  min-height: 300px;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/financial-report/basic-info/detail.vue